import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
//fontawesome
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ROUTE_AMLS_SMART_SCREENING } from '../../../../constants/globalConstants';
const { Text } = Typography;

import styles from './index.scss';
import { RIModuleTypes } from '../../constants';
import { convertISOToDateTimeFormat } from '../../../../../util/timezone';
import useAlertLevelConfigs from '../../../../common/hooks/useAlertLevelConfig';

import { orderBy } from '../../../../../util/lodashlike';
export const NSDeployToProductionTopPannel = ({
  GS,
  navigateTo,
  data,
  alertLevels
}) => {
  const { getLevelColor } = useAlertLevelConfigs(alertLevels);

  const getDeployToProductionTopPanel = () => {
    let renderData = null;
    const customColumns = [
      'alertLevels',
      'executionStatus',
      'name',
      'createdBy',
      'type'
    ];
    if (GS && data) {
      const sortedSettings = orderBy(
        GS.widgetConfig,
        ['columnIndex'],
        ['asc']
      ).filter((column) => column.columnVisibility);
      renderData = sortedSettings.map((setting, key) => {
        return (
          <div className={styles.list} key={key}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => {
                return (
                  <React.Fragment>
                    {column?.itemName === 'alertLevels' && (
                      <React.Fragment key={idx}>
                        <div className={styles.list_head}>
                          {column.itemLabel}
                        </div>
                        <div className={styles.list_content}>
                          <div className={styles.alertLevels}>
                            <div
                              style={{
                                color: getLevelColor('High'),
                                display: 'flex',
                                alignItems: 'center'
                              }}>
                              <div
                                style={{
                                  height: '15px',
                                  width: '15px',
                                  border: `1px solid ${getLevelColor('High')}`,
                                  background: getLevelColor('High'),
                                  marginRight: '10px'
                                }}>
                                <span style={{ color: '#fff' }}>&#8593;</span>
                              </div>
                              {data[column.itemName]?.High?.toString()
                                ? data[column.itemName]?.High?.toLocaleString(
                                    'en-US'
                                  )
                                : '--'}
                            </div>
                            <div
                              style={{
                                color: getLevelColor('Good'),
                                display: 'flex',
                                alignItems: 'center'
                              }}>
                              <div
                                style={{
                                  height: '15px',
                                  width: '15px',
                                  border: `1px solid ${getLevelColor('Good')}`,
                                  background: getLevelColor('Good'),
                                  marginRight: '10px'
                                }}>
                                <span style={{ color: '#fff' }}>&#8212;</span>
                              </div>
                              {data[column.itemName]?.Good?.toString()
                                ? data[column.itemName]?.Good?.toLocaleString(
                                    'en-US'
                                  )
                                : '--'}
                            </div>
                            <div
                              style={{
                                color: getLevelColor('Low'),
                                display: 'flex',
                                alignItems: 'center'
                              }}>
                              <div
                                style={{
                                  height: '15px',
                                  width: '15px',
                                  border: `1px solid ${getLevelColor('Low')}`,
                                  background: getLevelColor('Low'),
                                  marginRight: '10px'
                                }}>
                                <span style={{ color: '#fff' }}>&#8595;</span>
                              </div>
                              {data[column.itemName]?.Low?.toString()
                                ? data[column.itemName]?.Low?.toLocaleString(
                                    'en-US'
                                  )
                                : '--'}
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    {column?.itemName === 'executionStatus' && (
                      <React.Fragment key={idx}>
                        <div className={styles.list_head}>
                          {column.itemLabel}
                        </div>
                        <div
                          className={styles.list_content}
                          style={{
                            color:
                              data[column.itemName]?.toLowerCase() ===
                              'completed'
                                ? '#71C969'
                                : data[column.itemName]?.toLowerCase() ===
                                  'failed'
                                ? '#df6057'
                                : '#748aa1'
                          }}>
                          {data[column.itemName] ? data[column.itemName] : '--'}
                        </div>
                      </React.Fragment>
                    )}
                    {(column?.itemName === 'name' ||
                      column?.itemName === 'createdBy') && (
                      <React.Fragment key={idx}>
                        <div className={styles.list_head}>
                          {column.itemLabel}
                        </div>
                        <div className={styles.list_content}>
                          <Text ellipsis={{ tooltip: data[column.itemName] }}>
                            {data[column.itemName]
                              ? data[column.itemName]
                              : '--'}
                          </Text>
                        </div>
                      </React.Fragment>
                    )}
                    {column?.itemName === 'type' && (
                      <React.Fragment key={idx}>
                        <div className={styles.list_head}>
                          {column.itemLabel}
                        </div>
                        <div className={styles.list_content}>
                          {data[column.itemName]
                            ? RIModuleTypes[data[column.itemName]]
                            : '--'}
                        </div>
                      </React.Fragment>
                    )}
                    {!customColumns.includes(column?.itemName) && (
                      <React.Fragment key={idx}>
                        <div className={styles.list_head}>
                          {column.itemLabel}
                        </div>
                        <div className={styles.list_content}>
                          {data[column.itemName]
                            ? column.itemName === 'createdAt' ||
                              column.itemName === 'updatedAt'
                              ? convertISOToDateTimeFormat(
                                  data[column.itemName]
                                )
                              : data[column.itemName]
                            : '--'}
                        </div>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                );
              })}
          </div>
        );
      });
    }

    return renderData;
  };

  if (GS?.isVisible)
    return (
      <div className={styles.wrapper}>
        <div className={styles.head} id="deployToProduction-head">
          <div className={styles.alignCenter}>
            <div
              id="backarrowBtn"
              onClick={() =>
                navigateTo(`${ROUTE_AMLS_SMART_SCREENING}/runInstance`)
              }
              style={{ cursor: 'pointer' }}>
              <FontAwesomeIcon icon={faArrowLeft} color={'#000'} />
            </div>
            <h4>Deploy In Production</h4>
          </div>
        </div>
        <div className={styles.head_content}>
          {getDeployToProductionTopPanel()}
        </div>
      </div>
    );
  else return null;
};

NSDeployToProductionTopPannel.propTypes = {
  GS: PropTypes.object.isRequired,
  navigateTo: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  alertLevels: PropTypes.array
};

export default NSDeployToProductionTopPannel;
